import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from "@angular/router";
import { MAT_PAGINATOR_DEFAULT_OPTIONS, MatPaginatorIntl } from "@angular/material/paginator";
import { DragDropModule } from '@angular/cdk/drag-drop';

import { NgxMaskModule } from "ngx-mask";
import { TranslateModule } from "@ngx-translate/core";

import { TableComponent } from './table.component';
import { TablePaginatorComponent } from './paginator/table-paginator.component';
import { TablePaginatorService } from "./paginator/table-paginator.service";
import { AngularMaterialModule } from "../../../../core/angular-material/angular-material.module";
import { FormModule } from "../../default/form/form.module";
import { ProgressSpinnerModule } from "../../default/progress-spinner/progress-spinner.module";
import { NoResultsModule } from "../../default/no-results/no-results.module";
import { AvatarModule } from "../../default/avatar/avatar.module";
import { DirectivesModule } from "../../../directives/directives.module";
import { BadgeModule } from "../../default/badge/badge.module";
import { IconModule } from "../../default/icon/icon.module";

@NgModule({
    declarations: [
        TableComponent,
        TablePaginatorComponent
    ],
    imports: [
        CommonModule,
        AngularMaterialModule,
        FormModule,
        ProgressSpinnerModule,
        RouterModule,
        NgxMaskModule.forRoot({validation: false}),
        TranslateModule,
        NoResultsModule,
        AvatarModule,
        DirectivesModule,
        DragDropModule,
        BadgeModule,
        IconModule
    ],
    exports: [
        TableComponent,
        TablePaginatorComponent
    ],
    providers: [
        {
            provide: MatPaginatorIntl,
            useClass: TablePaginatorService
        },
        {
            provide: MAT_PAGINATOR_DEFAULT_OPTIONS,
            useValue: {
                formFieldAppearance: 'standard',
            }
        }
    ]
})
export class TableModule{}
